import React, { Component } from 'react'
import { connect } from 'react-redux'
import { renderNothing, branch, lifecycle, compose, nest } from 'recompose'
import Dialog from 'react-toolbox/lib/dialog'
import styles from './styles.scss'
import CSSModules from 'helpers/CSSModulesUtil'
import { revisionHeadersSelector  } from '../selectors'
import { nvqualStatusSourceSelector } from 'containers/Project/NvqualSection/selectors'
import {
    Table,
      TableHead,
      TableRow,
      TableCell
  } from 'react-toolbox'
  import T from 'i18n-react'
import { changeCurrentRevision } from 'containers/Project/NvqualSection/actions'
import { Flex } from 'reflexbox'
import { getMonthDayYear } from 'helpers/DateUtil'
import StatusChip from '../Chip'
import { removeQueryParam } from 'helpers/Utils'
import _ from 'lodash'

const mapStateToProps = state => {
    return {
      revisionHeaders: revisionHeadersSelector(state),
      statusSource: nvqualStatusSourceSelector(state)
    }
  }
  
  const mapDispatchToProps = dispatch => {
    return {
        onSubmit: (revNum, revId) => dispatch(changeCurrentRevision(revNum, revId))
    }
  }

class RevisionDialog extends Component {

    constructor(props){
        super(props)
        this.state = {
            selected: null
        }
    }

    handleCancel = () => {
      const { toggleRevisionDialog } = this.props
      toggleRevisionDialog()
      this.setState({
        selected: null
      })
      removeQueryParam('action')
    }

    handleSubmit = () => {
        const { onSubmit, toggleRevisionDialog, revisionHeaders } = this.props
        const { selected } = this.state
        onSubmit(selected, revisionHeaders.find(x => x.revisionNumber == selected).id)
        toggleRevisionDialog()
    }

    getStatusText = (statusNum) => {
      const { statusSource } = this.props
      const status = statusSource.find(x => x.value == statusNum)
      return !status ? "N/A" : status.label
    }

    onSelect(idx) {
        this.setState({
            selected: idx
        })
    }

    renderRevisionsTableHeader() {
        return(
            <TableHead>
                <TableCell key={`num`}><div className={styles.textNum}>Revision #</div></TableCell>
                <TableCell key={`name`}><div className={styles.textName}>Revision Name</div></TableCell>
                <TableCell key={`nvbugId`}><div className={styles.textName}>NVBugs ID</div></TableCell>
                <TableCell key={`created`}><div className={styles.textCreated}>Date Created</div></TableCell>
                <TableCell key={`approval`}><div className={styles.textApproval}>Status</div></TableCell>
                <TableCell key={`comments`}><div className={styles.textComments}>Comments</div></TableCell>
            </TableHead>
        )
    }

    renderRevisionsTableRow(){
        const { revisionHeaders } = this.props
        const { selected } = this.state
        return revisionHeaders && revisionHeaders.map ((r, idx) => {
            return (<TableRow key={idx} selected={selected == r.revisionNumber} onClick={this.onSelect.bind(this, r.revisionNumber)}>
                <TableCell key={`num${r.id}`}><div className={styles.textNum}>{r.revisionNumber}</div></TableCell>
                <TableCell key={`name${r.id}`}><div className={styles.textName}>{_.slice(r.name,0, 100)}</div></TableCell>
                <TableCell key={`nvbugId${r.id}`}><div className={styles.textName}><a href={`https://nvbugs/${r.nvbugId}`} target="_blank">{r.nvbugId}</a></div></TableCell>
                <TableCell key={`created${r.id}`}><div className={styles.textCreated}>{getMonthDayYear(new Date(r.createdAt))}</div></TableCell>
                <TableCell key={`approval${r.id}`}><div className={styles.textApproval}>
                <StatusChip text={this.getStatusText(r.nvqualResultId)}/>
                  </div></TableCell>
                <TableCell key={`comments${r.id}`}><div className={styles.textComments}>{_.slice(r.comments,0, 100)}</div></TableCell>
            </TableRow>)
            }
        )
    }

  render() {
    const { revisionDialog } = this.props
    const { selected } = this.state
    const actions = [
        { label: 'Cancel', onClick: this.handleCancel },
        { label: 'Change Revisions', onClick: this.handleSubmit, disabled: selected == null },
      ]
    return (
      <Dialog
      theme={styles}
      active={revisionDialog}
      onOverlayClick={this.handleCancel}
      onEscKeyDown={this.handleCancel}
      actions={actions}
      title={'Select A Revision'}
    >
        <Flex className={styles.wrapper}>
       <Table
       selectable
       multiSelectable={false}
       className={styles.table}
       >
        {this.renderRevisionsTableHeader()}
        {this.renderRevisionsTableRow()}
      </Table>
      </Flex>
    </Dialog>
    )
  }
}
const withConnect = connect(mapStateToProps, mapDispatchToProps)
const withStyle = CSSModules(styles)
const enhance = compose(
  withConnect,
  withStyle
)
export default enhance(RevisionDialog)
